import localeEn from '../data/translations/en';
import localeHr from '../data/translations/hr';
import localeSr from '../data/translations/sr';
import localeBh from '../data/translations/bh';

var translations = {
    hr: localeHr,
    en: localeEn,
    sr: localeSr,
    bh: localeBh,
};

const dict = (language) => {
    if (translations[language]) {
        return translations[language];
    } else {
        return translations.en;
    }
};

const translateBackend = (text, lang) => {
    if (dict(lang)[text]) {
        return dict(lang)[text];
    } else {
        return text;
    }
};

export default translateBackend;
